import { authorizationScopes } from 'lib-shared-user-role';
import { useMemo } from 'react';

import { featureFlags } from 'utils/featureFlagging/featureFlags';

type AuthorizationScopes = typeof authorizationScopes;

/**
 * Returns AuthorizationScopes, filtered out according to feature flags
 *
 * @returns AuthorizationScopes
 */
export const useAuthorizationScopes = (): AuthorizationScopes => {
  return useMemo(
    () =>
      Object.keys(authorizationScopes).reduce((scopes, sectionName) => {
        const sectionScopes = authorizationScopes[sectionName].filter(
          ({ featureFlags: requiredFlags, featureFlagsStrategy }) => {
            if (!requiredFlags) {
              return true;
            }

            const flags = featureFlags.get(requiredFlags);
            const flagNames = Object.keys(flags);

            return featureFlagsStrategy === 'any'
              ? flagNames.some((ff) => flags[ff])
              : flagNames.every((ff) => flags[ff]);
          },
        );

        if (sectionScopes.length) {
          scopes[sectionName] = sectionScopes;
        }

        return scopes;
      }, {} as AuthorizationScopes),
    [],
  );
};
